import {useGTMDispatch} from './react-gtm-hook/index'

export const useBannerTracking = (bannerSettings) => {
  const sendDataToGTM = useGTMDispatch()

  const sendBannerTrackingData = (eventType, clickText, bannerActionStatus) => {
    setTimeout(() => {
      try {
        const eventData = {
          event: eventType,
          banner_id: bannerSettings.bannerId,
          banner_name: bannerSettings.bannerName,
          banner_type: bannerSettings.bannerType,
          banner_slot: bannerSettings.bannerSlot,
          banner_format: bannerSettings.bannerFormat,
          banner_trigger_status: bannerSettings.bannerTriggerStatus,
        }

        if (clickText !== undefined) {
          eventData.click_text = clickText
        }

        if (bannerActionStatus !== undefined) {
          eventData.banner_action_status = bannerActionStatus
        }

        sendDataToGTM(eventData)
      } catch (error) {
        console.error('useBannerTracking error: ' + error.message)
      }
    }, 0)
  }

  return sendBannerTrackingData
}
